module.exports = "/images/vendor/flag-icon-css/flags/4x3/jp.svg?3e72015c537875435192c3b2d832042e";